export default __webpack_public_path__ + "static/work-a7543a1216dc3685b01cdc789bfcdf5a.png";